import { render, staticRenderFns } from "./pesananbuktiiklan.vue?vue&type=template&id=1120ae8e"
import script from "./pesananbuktiiklan.vue?vue&type=script&lang=js"
export * from "./pesananbuktiiklan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports